import { motion } from 'framer-motion'
import { featureModules } from '@/components/home/home-data'
import { blockCard } from '@/lib/ui-classes'

const fadeIn = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
}

export function FeatureModuleGrid() {
  return (
    <section id="features" className="relative bg-zinc-950 px-4 py-24 sm:px-6">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#07F4F2]/35 to-transparent" />
      <div className="absolute left-10 top-20 h-64 w-64 rounded-full bg-[#07F4F2]/8 blur-3xl" />

      <div className="relative z-10 mx-auto max-w-7xl">
        <motion.div {...fadeIn} className="mx-auto mb-16 max-w-3xl text-center">
          <h2 className="text-3xl font-semibold text-white md:text-5xl">核心功能模块</h2>
          <p className="mt-6 text-lg leading-8 text-zinc-400">
            覆盖剧本、元素、分镜、配音、合成与导出，满足从立项到成片的完整创作需求。
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featureModules.map(({ icon: Icon, title, desc, tag }) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.45 }}
              className={`${blockCard} rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#07F4F2]/30 hover:bg-white/[0.05]`}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-black/35">
                  <Icon className="h-7 w-7 text-[#07F4F2]" />
                </div>
                {tag && (
                  <span className="rounded-full border border-[#07F4F2]/20 bg-[#07F4F2]/10 px-3 py-1 text-xs font-medium text-[#C1FAB8]">
                    {tag}
                  </span>
                )}
              </div>
              <h3 className="mt-6 text-2xl font-semibold text-white">{title}</h3>
              <p className="mt-4 text-base leading-7 text-zinc-400">{desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
